import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Auth from '../../components/Auth';
import Footer from 'components/Nav/Footer';
import Navbar from 'components/Nav/Navbar';

const HomeIndex = () => {
  return (
    <Box className="eclipse">
      <Box sx={{ py: { xs: 2, sm: 2, md: 6, lg: 6 }, px: { xs: 1, sm: 1, md: 4, lg: 20 } }} style={{ maxWidth: '1080px', margin: '0 auto' }}>
        <Navbar />
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} md={7}>
              <Box py={6} pr={2}>
                <Typography
                  sx={{ textAlign: { xs: 'center', md: 'left' }, fontSize: { xs: '2rem', sm: '3.4rem' } }}
                  variant="h3"
                  color="primary.light"
                  fontWeight="700"
                  style={{ fontFamily: 'Open Sans' }}
                >
                  ¡Bienvenido a tu portal!
                </Typography>
                <Box pt={4}>
                  <Typography sx={{ textAlign: { xs: 'center', md: 'left' }, fontSize: { xs: '1.1rem', sm: '1.4rem' } }} variant="h6" fontWeight="bold">
                    Monitoreá las métricas más importantes de tus transacciones y tu negocio de una manera simple y clara. Usalas para garantizar la mejor experiencia para tus usuarios y encontrar puntos de mejora.
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={5}>
              <Auth />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box pt={2} style={{ maxWidth: '1080px', margin: '0 auto' }}>
        <Footer />
      </Box>
    </Box>
  );
};

export default HomeIndex;
